import {
  GridToolbarQuickFilter,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
} from '@mui/x-data-grid-pro';

// ----------------------------------------------------------------------

// Simple wrappers around MUI's built-in toolbar components
// These are available in DataGridPro

export function CustomToolbarColumnsButton() {
  return <GridToolbarColumnsButton />;
}

export function CustomToolbarFilterButton() {
  return <GridToolbarFilterButton />;
}

export function CustomToolbarExportButton() {
  return <GridToolbarExport />;
}

export function CustomToolbarQuickFilter() {
  return (
    <GridToolbarQuickFilter
      sx={{ width: 1, maxWidth: { md: 260 }, mr: 2 }}
      debounceMs={500}
      variant="outlined"
      size="small"
    />
  );
}
